export var ankerGnav, nowPosition, nowScroll, floorLayoutWrap, wH, sectionPos, navList, sectionTopArr, current, margin, changeNavCurrent, curNum2;
ankerGnav = '#gnav';
floorLayoutWrap = '.firstFloorLayout';
navList = '#gnav li';
sectionTopArr = new Array;
current = -1;
margin = 100;
export function facilityFunc() {
    nowScroll = $(window).scrollTop();
    //console.log('現在のスクロール量は:'+nowScroll);
    nowPosition = $(floorLayoutWrap).offset().top;

    if (nowScroll > nowPosition) {
        $(ankerGnav).addClass('active');
    } else {
        $(ankerGnav).removeClass('active');
    }
    wH = $(window).height();
    sectionPos = $('#first').offset().top;

    //(1)各sectionの縦位置を取得
    $('.floorLayoutWrap').find('section').each(function (i) {
        sectionTopArr[i] = $(this).offset().top;
    });
    //console.log('配列に入ってる距離は:'+sectionTopArr);

    //(2)各セクションの位置とスクロール位置を比較して、条件にあったらchangeNavCurrentを実行
    for (var i = sectionTopArr.length - 1; i >= 0; i--) {
        if (nowScroll > sectionTopArr[i] - margin) {
            changeNavCurrent(i);
            break;
        }
    }
    //(3)ナビの処理
    function changeNavCurrent(curNum) {
        if (curNum != current) {
            current = curNum;
            curNum2 = curNum + 1; //HTML順序用
            $('#gnav li').removeClass('current');
            $('#gnav li:nth-child(' + curNum2 + ')').addClass('current');
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/_facility.js
// module id = 11
// module chunks = 0